<div class="top-bar-wrapper">
  <div class="collapse" style="cursor: pointer;">
    <em nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'" (click)="toggleCollapsed()"></em>
  </div>
  <div class="title">
    <nz-breadcrumb class='breadcrumb' [nzAutoGenerate]="true" [nzRouteLabel]="'breadcrumbStr'"
      [nzRouteLabelFn]="translateFn">
      <nz-breadcrumb-item *ngFor="let label of breadcrumbLabels">
        {{ label | translate }}
      </nz-breadcrumb-item>
    </nz-breadcrumb>
  </div>

  <div *ngIf="SystemTimezone"
    style="font-family: 'Roboto';font-style: normal; width: 200px; font-weight: 500;font-size: 14px; align-items: center;">
    {{ 'TimeZone' | translate }}: {{SystemTimezone}}</div>

  <div class="switchedExpiration" *ngIf="isAllowAdminSwitch&&isAdminSwitchedUser">
    {{ 'SwitchedUserExpiration' | translate }}: {{ switchedTokenRemaining | date: 'HH:mm:ss' :
    'UTC' }}
  </div>
  <div class="user-info">
    <div>
      <span>
        <a class="user-info-front" nz-dropdown [nzDropdownMenu]="menu" style="font-size: 14px; color: rgb(0, 10, 15);">
          {{userInfo.displayName ? userInfo.displayName : 'Unknow Account'}}

        </a>
        <span nz-icon nzType="global" nzTheme="outline" nz-dropdown [nzDropdownMenu]="menu1"
          style="font-size: 14px; color: rgb(0, 10, 15);" nzCursor="pointer">
        </span>

        <nz-dropdown-menu style="width: 112px;" #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item nzTheme="outline" class="logout-item" (click)="showAccountInfo()">
              <em nz-icon nzType="user" class="logout-icon"></em>
              {{ "AccountInformation" | translate }}
            </li>
            <!-- <div style="text-align:left;">
            <li nz-submenu nzTitle='{{"Language"|translate}}'>
              <ul *ngFor="let language of languageItems ; let i = index"  >
                <li nz-menu-item (click)="switLanguage(language.value)">
                  {{language.lable}}</li>
              </ul>
            </li>
          </div> -->


            <div class="menu-items-wrapper">
              <li nz-menu-item nzTheme="outline" class="logout-item" (click)="showHelpInfo()">
                <em nz-icon nzType="read" class="logout-icon"></em>
                {{ "HelpCenter" | translate }}
              </li>

            </div>

            <li nz-menu-item nzTheme="outline" *ngIf="isAllowAdminSwitch&&!isAdminSwitchedUser" class="logout-item"
              (click)="adminSwitchUser()">
              <em nz-icon nzType="swap" nzTheme="outline" class="logout-icon"></em>
              {{ "SwitchAccount" | translate }}
            </li>
            <li nz-menu-item nzTheme="outline" *ngIf="isAllowAdminSwitch&&isAdminSwitchedUser" class="logout-item"
              (click)="existAdminSwitch()">
              <em nz-icon nzType="logout" nzTheme="outline" class="logout-icon"></em>
              {{ "ExistSwitchAccount" | translate }}
            </li>
            <li nz-menu-item nzTheme="outline" *ngIf="showIdentitySwitch" class="logout-item"
              (click)="identitySwitch()">
              <em nz-icon nzType="swap" nzTheme="outline" class="logout-icon"></em>
              {{ "SwitchIdentities" | translate }}
            </li>
            <li nz-menu-item nzTheme="outline" class="logout-item" (click)="logout()">
              <em nz-icon nzType="logout" class="logout-icon"></em>
              {{ "logout" | translate }}
            </li>
          </ul>
        </nz-dropdown-menu>
        <nz-dropdown-menu #menu1="nzDropdownMenu">
          <ul nz-menu>

            <div style="text-align:left;">

              <li nz-menu-item (click)="switLanguage(language.value)"
                *ngFor="let language of languageItems ; let i = index" style="font-size: 14px;">
                {{language.lable}}</li>

            </div>

          </ul>
        </nz-dropdown-menu>
      </span>
      <!-- <span class="pointer" style="font-size: 10px;" (click)="onEdit()">{{"HelpCenter"|translate}}</span>
    <span style="height:100px; width:1px; border-left:1px #000 solid"></span>
    <span class="pointer" style="font-size: 10px;width: 50px;margin-left: 5px;" (click)="logout()">{{"logout"|translate}}</span> -->
    </div>
  </div>
</div>